// Phase RV-6a — /rollover/flex page.
//
// Source: ROLLOVER Intelligence Enhancement v1.0 §11.2 (FLEX Builder).
//
// Anon-friendly read for the builder area; lock RPC requires auth.
// FLEX History panel + Personal Conviction Score land in RV-6b.
//
// Rewired to the Football Products design kit (FpHead) — chrome from the
// `.fp` scoped layer. Neutral surfaces only; accent reserved for typography.

import { FlexBuilderPanel } from "../../components/rollover-extras/FlexBuilderPanel.tsx";
import { FlexHistoryPanel } from "../../components/rollover-extras/FlexHistoryPanel.tsx";
import { PersonalConvictionScore } from "../../components/rollover-extras/PersonalConvictionScore.tsx";
import { useAuthSession } from "../../auth/useAuthSession.ts";
import { useUpcomingBoard } from "../../rollover/useUpcomingBoard.ts";
import { DoctrineSection } from "../../components/DoctrineSection.tsx";
import { useDoctrinePicks } from "../../doctrine/useDoctrinePicks.ts";
import { FpHead } from "../football/_fpkit.tsx";

export function RolloverFlexPage(): JSX.Element {
  const { user } = useAuthSession();
  const board = useUpcomingBoard();
  const {
    probabilityPicks: doctrineProbPicks,
    valuePicks: doctrineValuePicks,
    substrateEmpty,
    substrateWeek,
  } = useDoctrinePicks({ t1HasPicks: board.candidates.length > 0 });
  return (
    <div className="fp" data-screen-label="03 ROLLOVER · FLEX">
      <FpHead
        kicker="STRIKZA · ROLLOVER · FLEX"
        title="FLEX BUILDER"
      />
      <div
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 12,
          color: "var(--text-tertiary)",
          lineHeight: 1.5,
          maxWidth: 640,
          margin: "0 0 4px",
        }}
      >
        A personal side bet across this window's candidates. Cross-tier legs
        allowed. Outcomes have zero effect on your active chain.
      </div>

      <FlexBuilderPanel
        pool={board.candidates}
        windowLabel={board.windowLabel}
        windowPublicationAt={board.publishedAt}
        isAuthed={Boolean(user)}
      />

      <FlexHistoryPanel isAuthed={Boolean(user)} />

      <PersonalConvictionScore isAuthed={Boolean(user)} />

      <DoctrineSection
        probabilityPicks={doctrineProbPicks}
        valuePicks={doctrineValuePicks}
        isFullFallback={board.candidates.length === 0}
        substrateEmpty={substrateEmpty}
        substrateWeek={substrateWeek}
      />
    </div>
  );
}
